import React from 'react';
import { MapPinIcon, MailIcon, PhoneIcon } from 'lucide-react';
export const ContactSection = () => {
  return <section id="contact" className="py-16 bg-white" data-id="element-34">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-35">
        <div className="lg:text-center" data-id="element-36">
          <h2 className="text-base text-[#D4AF37] font-semibold tracking-wide uppercase" data-id="element-37">
            Get In Touch
          </h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-slate-800 sm:text-4xl" data-id="element-38">
            Contact Us
          </p>
          <p className="mt-4 max-w-2xl text-xl text-slate-600 lg:mx-auto" data-id="element-39">
            We're currently managing investments for family and close friends.
            If you're interested in learning more about our future plans, please
            reach out.
          </p>
        </div>
        <div className="mt-16 lg:grid lg:grid-cols-2 lg:gap-8" data-id="element-40">
          <div className="relative mb-12 lg:mb-0" data-id="element-41">
            <div className="bg-white py-10 px-6 shadow-lg rounded-lg" data-id="element-42">
              <form action="#" method="POST" className="grid grid-cols-1 gap-y-6" data-id="element-43">
                <div data-id="element-44">
                  <label htmlFor="name" className="block text-sm font-medium text-slate-700" data-id="element-45">
                    Full name
                  </label>
                  <div className="mt-1" data-id="element-46">
                    <input type="text" name="name" id="name" autoComplete="name" className="py-3 px-4 block w-full shadow-sm focus:ring-[#D4AF37] focus:border-[#D4AF37] border-slate-300 rounded-md" data-id="element-47" />
                  </div>
                </div>
                <div data-id="element-48">
                  <label htmlFor="email" className="block text-sm font-medium text-slate-700" data-id="element-49">
                    Email
                  </label>
                  <div className="mt-1" data-id="element-50">
                    <input id="email" name="email" type="email" autoComplete="email" className="py-3 px-4 block w-full shadow-sm focus:ring-[#D4AF37] focus:border-[#D4AF37] border-slate-300 rounded-md" data-id="element-51" />
                  </div>
                </div>
                <div data-id="element-52">
                  <label htmlFor="message" className="block text-sm font-medium text-slate-700" data-id="element-53">
                    Message
                  </label>
                  <div className="mt-1" data-id="element-54">
                    <textarea id="message" name="message" rows={4} className="py-3 px-4 block w-full shadow-sm focus:ring-[#D4AF37] focus:border-[#D4AF37] border-slate-300 rounded-md" data-id="element-55"></textarea>
                  </div>
                </div>
                <div data-id="element-56">
                  <button type="submit" className="w-full inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-[#D4AF37] hover:bg-[#C9A227] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#D4AF37]" data-id="element-57">
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="relative" data-id="element-58">
            <div className="bg-white py-10 px-6 shadow-lg rounded-lg h-full" data-id="element-59">
              <h3 className="text-lg font-medium text-slate-800 mb-6" data-id="element-60">
                Our Information
              </h3>
              <div className="p-6 text-center" data-id="element-61">
                <p className="text-xl font-bold text-[#D4AF37] mb-4" data-id="element-62">
                  Coming Soon
                </p>
                <p className="text-slate-600" data-id="element-63">
                  We're in the process of establishing our presence in the
                  Indian market. Our contact information and office details will
                  be available shortly.
                </p>
                <p className="mt-4 text-slate-600" data-id="element-64">
                  Please use the contact form to get in touch with us in the
                  meantime.
                </p>
              </div>
              <div className="mt-10" data-id="element-65">
                <h3 className="text-lg font-medium text-slate-800 mb-4" data-id="element-66">
                  Office Hours
                </h3>
                <div className="space-y-2 text-base text-slate-600" data-id="element-67">
                  <p data-id="element-68">Monday - Friday: 9:00 AM - 5:00 PM</p>
                  <p data-id="element-69">Saturday - Sunday: Closed</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};